/**
 * Checks whether an atom type key in attachments already exists.
 *
 * @param {Correlation} correlation
 * @param {string} atomType
 */
export function hasAttachmentAtomType(correlation, atomType) {
    return correlation.attachment[atomType] &&
        correlation.attachment[atomType].length > 0
        ? true
        : false;
}
//# sourceMappingURL=hasAttachmentAtomType.js.map